<div class="container-fluid">
	<h1 class="my-3">Preferencias Artículo en sucursal</h1>
	<div class="card py-3 mx-1 px-2">
		<div class="row fw-bold mx-0 border-bottom">
			<div class="col-4">Artículo</div>
			<div class="col-4">Sucursal</div>
			<div class="col-4">Preferencia</div>
		</div>
		<div class="row py-1 align-items-center border-bottom mx-0" *ngFor="let isi of cs_info_list">
			<div class="col-4">{{isi.item.name}}</div>
			<div class="col-8">
				<div *ngFor="let cs of isi.item_store_info_list" class="row align-items-center">
					<div class="col-6">{{cs.store.name }}</div>
					<div class="col-4 form-group">
						<select class="form-control" [name]="'CSI'+isi.item.id+'-'+cs.store.id" [ngModel]="cs.item_store.pos_preference" (ngModelChange)="update(cs.item_store,$event)">
							<option value="SHOW">Mostrar</option>
							<option value="HIDE">Esconder</option>
						</select>
					</div>
					<div class="col-4 form-group">
						<select class="form-control" [name]="'CSIO'+isi.item.id+'-'+cs.store.id" [ngModel]="cs.item_store.is_available_online" (ngModelChange)="updateX(cs.item_store,$event)">
							<option value="0">Disponible En Linea</option>
							<option value="1">No Disponible En Linea</option>
						</select>
					</div>
				</div>
			</div>
		</div>
	</div>
	<app-pagination [path]="path" [total_pages]="total_pages" [current_page]="current_page"></app-pagination>
</div>
